import React from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Link } from "react-router-dom";

const WebDeveloper = () => {
  return (
    <section className="webdevelopment-section">
      <div className="develop-banner">
        <div className="container-layout">
          <Row className="development-rows">
            <Col lg={12}>
              <div className="develop-ban-content">
                <div className="safe-para">
                  <p>SAFE</p>
                  <p>/</p>
                  <p>SECURE</p>
                  <p>/</p>
                  <p>PRIVATE</p>
                </div>
                <h1>Web Development</h1>
                <p>
                  Develop client-emphasized and business-reliant interactive
                  portals <br /> and websites using various web development
                  strategies & platform
                </p>
                <Link to="/contact" className="btn contact_btn">CONTACT US</Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="devel-second-section">
        <div className="container-layout">
          <Row>
            <Col lg={12}>
              <div className="second-sec-details">
                <h6>RELIABLE WEB DEVELOPMENT SOLUTIONS!</h6>
                <h2>Web Development</h2>
                <p>
                  Along with top-quality and attractive design ideas, our team
                  at Gs Infotech Web Solutions has also combined the experience of web
                  developers to create aligned, clean, and easy-to-access web
                  interfaces. We use modern tools and approachable design
                  principles, which are going to unlock more value for a
                  business. We are professionals to develop robustly and
                  maintained websites. We understand the complexity of
                  developing a website, as well as, maintaining it. This is
                  where we can handle the website’s working with ease. Using our
                  experience and knowledge of several years in the web
                  development industry, we are at #1 because of our distinct web
                  development packages and solutions. With our web development
                  solutions, your website can touch the peak point of online
                  excellence. We offer:
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ul className="php-dev">
                <li>
                  <ArrowRightAltIcon />
                  PHP Development
                </li>
                <li>
                  <ArrowRightAltIcon />
                  Asp.Net Development
                </li>
                <li>
                  <ArrowRightAltIcon />
                  Ecommerce Solutions
                </li>
                <li>
                  <ArrowRightAltIcon />
                  WordPress Development
                </li>
                <li>
                  <ArrowRightAltIcon />
                  CMS Development
                </li>
                <li>
                  <ArrowRightAltIcon />
                  Website Testing
                </li>
              </ul>
            </Col>
          </Row>
          <p>
            We have talented and knowledgeable developers, who first apprehend
            the requirements of clients and start putting their hard efforts
            into developing the website after getting the design ready from
            designers. A website is the first and last impression of your
            website when it comes to online marketing. This is why we do not
            want you to take any risk with the web development part. Hire our
            team of professional developers, who will be able to use engaging
            methodologies and enhance the online presence and brand values.{" "}
            <br /> In addition to that, we also ensure quality control using our
            time-proven strategy so that we can provide you with a user-friendly
            and well-developed web platform. If you want to attain long-term
            success in your business, then make sure to hire our developers.
            Visit us and explain what you want or which platform you need to use
            for web or app development, we are capable of handling everything
            with expertise and determination. Contact us or hire us now.
          </p>
        </div>
      </div>
      <div className="faq_Sec">
        <div className="container-layout">
          <h2 className="text-center">
            Frequently Asked <span>Questions</span>
          </h2>
          <p className="text-center">
            A small river named Duden flows by their place and supplies it with
            the necessary regelialia. It is a paradise
          </p>
          <div className="row faq_row">
            <Col xl={12}>
              <div className="faq_accordion">
                <Accordion defaultActiveKey="">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      {" "}
                      How to Change my Photo from Admin Dashboard?{" "}
                    </Accordion.Header>
                    <Accordion.Body>
                      Far far away, behind the word mountains, far from the
                      countries Vokalia and Consonantia, there live the blind
                      texts. Separated they live in Bookmarksgrove right at the
                      coast.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      {" "}
                      How to Change my Password easily?
                    </Accordion.Header>
                    <Accordion.Body>
                      Far far away, behind the word mountains, far from the
                      countries Vokalia and Consonantia, there live the blind
                      texts. Separated they live in Bookmarksgrove right at the
                      coast
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      {" "}
                      How to Change my Subscription Plan using PayPal?
                    </Accordion.Header>
                    <Accordion.Body>
                      Far far away, behind the word mountains, far from the
                      countries Vokalia and Consonantia, there live the blind
                      texts. Separated they live in Bookmarksgrove right at the
                      coast
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Col>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebDeveloper;
